import { OnInit, Component, Output, EventEmitter, Input} from '@angular/core';

import { UtilsService } from '../../../../services/utils.service';

@Component({
	selector: 'app-pagehbuttons',
	templateUrl: './pagehbuttons.component.html',
	styles: []
})
export class PagehbuttonsComponent  {
	@Output() recibirRealoadEvent = new EventEmitter<boolean>();

	@Input() statusevent:boolean;
	@Input() backbutton:any;


	constructor(private utilsService:UtilsService){

	}



	action: boolean = true;

	regargar() {
		this.recibirRealoadEvent.emit(this.action);
	}

	async ngOnInit(){
		let rutaprev:string = await this.utilsService.obtenerRutaPrevia();

		//console.log('rutaprev: ', rutaprev);

		if(rutaprev){
			this.backbutton.link = rutaprev;
		}
		
	}


	eliminarRutaprevia(){
		this.utilsService.limpiarRutaPrevia() 
	}
	

}
